import { BsFillCloudArrowUpFill } from "react-icons/bs";
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
} from "../../shadcn-components/ui/card";

import { Skeleton } from "../../shadcn-components/ui/skeleton";
import { useEffect, useState } from "react";
import dashboardPendingRequests from "../../api/dashboardPendingRequests";
import { Link } from "react-router-dom";
import { useRoleContext } from "../../context/RolesContext";

function PendingRequestsCard({ customBoxShadow, token, is_admin }) {
  const [
    dashboardPendingRequestsResponse,
    setDashboardPendingRequestsResponse,
  ] = useState({});
  const [loading, setLoading] = useState(true);

  // Function to check if the user has a specific permission.
  // Admin users ("is_admin" === "1") automatically have access to all permissions.
  const { permissions } = useRoleContext();
  const hasPermission = (permission) => {
    if (is_admin === "1") {
      return true;
    }

    return permissions.includes(permission);
  };

  // Permission flags for various user actions, granting access based on user roles or admin status.
  // Admin users have all permissions by default.
  const canViewRequestedDocuments = hasPermission("view_requested_documents");

  const dashboardPendingRequestsData = async () => {
    const response = await dashboardPendingRequests({ token });
    if (response.code === 200) {
      setDashboardPendingRequestsResponse(response.data);
    }
  };

  useEffect(() => {
    async function fetchData() {
      await dashboardPendingRequestsData();
      setLoading(false);
    }
    fetchData();
  }, []);

  return (
    <Card style={customBoxShadow}>
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center justify-between gap-3 notification-title-requests letterSpacing">
          <p className="text-base font-semibold text-gray-800">
            Pending Requests
          </p>
          <span className="request-doc-request-icon request-doc-icon text-teal-700 transition-transform duration-300 hover:scale-110">
            <BsFillCloudArrowUpFill />
          </span>
        </CardTitle>
      </CardHeader>

      <CardContent className="overflow-y-scroll notification-container">
        {!loading ? (
          dashboardPendingRequestsResponse.length > 0 ? (
            dashboardPendingRequestsResponse.map((pendingRequests) => (
              <div
                className="latest-notification"
                key={pendingRequests.contact_id}
              >
                {canViewRequestedDocuments ? (
                  <Link
                    to={`/clients/${pendingRequests.contact_id}`}
                    className="go-to-password-reset-form"
                    target="_blank"
                  >
                    {pendingRequests.name}
                  </Link>
                ) : (
                  <div className="go-to-password-reset-form opacity-70 cursor-not-allowed">
                    {pendingRequests.name}
                  </div>
                )}
              </div>
            ))
          ) : (
            <div className="latest-notification">No pending requests</div>
          )
        ) : (
          <div className="space-y-4">
            {Array(10)
              .fill(0)
              .map((_, index) => (
                <Skeleton key={index} className="h-6 w-full" />
              ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}

export default PendingRequestsCard;
